/**
 * Date utility functions
 */

/**
 * Converts a German date string (DD.MM.YYYY) to a JavaScript Date object
 */
export const convertToDate = (dateString: string): Date | null => {
  if (!dateString || dateString === '-') return null;
  
  // Handle German format DD.MM.YYYY
  const parts = dateString.split('.');
  if (parts.length === 3) {
    const [day, month, year] = parts.map(Number);
    return new Date(year, month - 1, day);
  }
  
  // Try standard Date parsing as fallback
  const parsed = new Date(dateString);
  return isNaN(parsed.getTime()) ? null : parsed;
};

/**
 * Calculates the age in years from a birthdate
 * Handles both Date objects and German-formatted date strings (DD.MM.YYYY)
 */
export const calculateAge = (birthdate: Date | string | null): number => {
  if (!birthdate) return 0;
  
  let birthDate: Date;
  
  if (typeof birthdate === 'string') {
    const converted = convertToDate(birthdate);
    if (!converted) return 0;
    birthDate = converted;
  } else {
    birthDate = birthdate;
  }
  
  const today = new Date();
  let age = today.getFullYear() - birthDate.getFullYear();
  const monthDifference = today.getMonth() - birthDate.getMonth();

  // Adjust age if birthday hasn't occurred this year yet
  if (
    monthDifference < 0 ||
    (monthDifference === 0 && today.getDate() < birthDate.getDate())
  ) {
    age--;
  }
  
  return age;
};

/**
 * Formats a Date object to German format (DD.MM.YYYY)
 */
export const formatToGermanDate = (date: Date): string => {
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();
  return `${day}.${month}.${year}`;
};
